import { Calculation } from "@/models/Calculation";
import { Federation } from "@/models/Federation";

const getChildFederations = (
  organizations: Federation[],
  nhoNumber: number
): Federation[] => {
  return (
    organizations?.find((org) => org.nhoNumber === nhoNumber)
      ?.childFederations ?? []
  );
};

const priorityClassGroupName = (priorityClass: number): string =>
  `Prioritetsklasse ${priorityClass}`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getSortedChildFederations = (
  childFederations: Federation[],
  childCalculations: Calculation[],
  organizations: Federation[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] => {
  const otherGroupName = "Døtre uten egen kalkulasjon";
  const anotherMotherGroupName = "Egen kalkulasjon, men annen mor";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const existingChildCalculations: any[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const otherChildCalculations: any[] = [];
  let priorityClasses: number[] = [];

  childFederations?.forEach((org) => {
    const calculation = childCalculations.find((calculation) => {
      return calculation.childNhoNumber === org.nhoNumber;
    });
    if (calculation != undefined) {
      existingChildCalculations.push({
        ...org,
        group: priorityClassGroupName(calculation.childPriorityClass),
      });
      priorityClasses.push(calculation.childPriorityClass);
    } else otherChildCalculations.push({ ...org, group: otherGroupName });
  });

  const sorted = [];

  priorityClasses = [...new Set(priorityClasses)].sort().reverse();

  priorityClasses.forEach((priorityClass) => {
    const header = priorityClassGroupName(priorityClass);
    sorted.push({ header });
    sorted.push(...existingChildCalculations.filter((x) => x.group == header));
  });

  sorted.push({ header: otherGroupName });
  sorted.push(...otherChildCalculations);

  const childOrgNumbers = childFederations?.map((org) => org.nhoNumber);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const childrenCalculationsWithAnotherMother: any[] = childCalculations
    .filter((x) => !childOrgNumbers.includes(x.childNhoNumber))
    .map((calc) => {
      const org = organizations?.find(
        (org) => org.nhoNumber == calc.childNhoNumber
      );
      return { ...org, group: anotherMotherGroupName };
    });

  if (childrenCalculationsWithAnotherMother.length) {
    sorted.splice(0, 0, { header: anotherMotherGroupName });
    sorted.splice(1, 0, ...childrenCalculationsWithAnotherMother);
  }

  return sorted;
};

const childCalculationExists = (
  nhoNumber: number,
  childCalculations: Calculation[]
): boolean => {
  return childCalculations.some((calculation) => {
    return calculation.childNhoNumber === nhoNumber;
  });
};

export {
  getChildFederations,
  getSortedChildFederations,
  childCalculationExists,
};
